<template>
  <div :class="{'full': isFullInfo, 'very-full': encumbranceDetail[encIndex] === 'true'}" class="left-menu-wrap" v-show="leftMenuDisplayMedia">
    <transition name="slide-hide">
      <ObjectDetailVue v-show="isFullInfo" @hideFullInfo="isFull = false" :pk="pk" :isFull="isFull" @emitFitBoundsFromDetail="showOnMap($event)" @editFromDetail="emitEdit($event)"></ObjectDetailVue>
    </transition>

    <transition name="slide-fade">
      <div v-show="!isFullInfo" class="left-menu">
        <div class="search">
          <!-- <button @click="qwe()">qwe</button> -->
          <img class="search-icon" src="@img/search.svg" alt="">
          <input class="search-input" type="text" placeholder="Найти..." v-model="searchResult" @input="searchInput($event)">
          <button v-if="inputNoEmpty" class="clear" @click="clearSearch()">
            <img src="@img/close.svg" alt="">
          </button>
          <div class="search-block" :class="{'is-active': isActive}">
            <label>
              <input type="radio" name="search-select" hidden checked>
              <img src="@img/check.svg" alt="">
              <span>Кадастровый номер</span>
            </label>
            <label>
              <input type="radio" name="search-select" hidden>
              <img src="@img/check.svg" alt="">
              <span>Адрес</span>
            </label>
            <label>
              <input type="radio" name="search-select" hidden>
              <img src="@img/check.svg" alt="">
              <span>Владелец</span>
            </label>
          </div>
        </div>
        <button class="hide-search" @click="hideLeftMenuDisplayMedia()">
          <img src="@img/down.svg" alt="">
        </button>
        <vue-custom-scrollbar :settings="settings" class="scroll-menu">
          <div class="items-wrap">
            <div
              class="left-menu-item"
              v-for="(land, index) in landList.edges"
              :key="index"
              @click="showOnMap(land.node.pk), activeItem(land.node.pk)"
              @dblclick="selectLand(land.node.pk)"
              :class="{active: land.node.pk === lastClickedIndex}">
              <div class="left-menu-text">
                <div class="cadastral">
                  <p class="cadastral-number">{{land.node.regNum}}</p>
                  <div v-if="!reinitIconGeometry" class="">
                    <div v-if="land.node.contourSet !== null && land.node.contourSet !== undefined" v-tooltip="{content: `${land.node.contourSet.edges.length > 0 ? 'Есть геометрия' : 'Нет геометрии'}`}" class="geometry">
                      <simple-svg
                        :src="require('@img/geometry.svg')"
                        :custom-class-name="`${land.node.contourSet.edges.length > 0 ? 'active-svg' : ''}`"
                      />
                    </div>
                  </div>
                </div>
                <p>{{land.node.location !== null && land.node.location.okatoSp !== null ? land.node.location.okatoSp.text : 'Нет данных'}}</p>
              </div>
              <div class="left-menu-functional">
                <button title="Редактировать" @click="emitEdit(land.node.pk)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.33334 2.66666H2.66668C2.31305 2.66666 1.97392 2.80713 1.72387 3.05718C1.47382 3.30723 1.33334 3.64637 1.33334 3.99999V13.3333C1.33334 13.6869 1.47382 14.0261 1.72387 14.2761C1.97392 14.5262 2.31305 14.6667 2.66668 14.6667H12C12.3536 14.6667 12.6928 14.5262 12.9428 14.2761C13.1929 14.0261 13.3333 13.6869 13.3333 13.3333V8.66666" stroke="#4E53E7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12.3333 1.66669C12.5986 1.40147 12.9583 1.25247 13.3333 1.25247C13.7084 1.25247 14.0681 1.40147 14.3333 1.66669C14.5986 1.9319 14.7476 2.29161 14.7476 2.66669C14.7476 3.04176 14.5986 3.40147 14.3333 3.66669L8.00001 10L5.33334 10.6667L6.00001 8.00002L12.3333 1.66669Z" stroke="#4E53E7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button title="Детальный просмотр" @click="selectLand(land.node.pk)">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 2H14V6" stroke="#4E53E7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M6 14H2V10" stroke="#4E53E7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M14 2L9.33333 6.66667" stroke="#4E53E7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M2 14L6.66667 9.33331" stroke="#4E53E7" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
            <div class="load-trigger" v-observe-visibility="visibilityChanged"></div>
            <div v-if="$apollo.queries.landList.loading && !isShowLoader" class="preloader">
              <svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
                <circle cx="170" cy="170" r="160" stroke="#4E53E7"/>
                <circle cx="170" cy="170" r="135" stroke="#404041"/>
                <circle cx="170" cy="170" r="110" stroke="#4E53E7"/>
                <circle cx="170" cy="170" r="85" stroke="#404041"/>
              </svg>
            </div>
            <div v-if="$apollo.queries.landList.loading && isShowLoader" class="preloader pr-2">
              <svg class="loader lr-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
                <circle cx="170" cy="170" r="160" stroke="#4E53E7"/>
                <circle cx="170" cy="170" r="135" stroke="#404041"/>
                <circle cx="170" cy="170" r="110" stroke="#4E53E7"/>
                <circle cx="170" cy="170" r="85" stroke="#404041"/>
              </svg>
            </div>
            <p style="text-align:center" v-if="noResult">Нет результатов</p>
          </div>
        </vue-custom-scrollbar>
        <div class="create-object" v-if="permisCreate">
          <button class="btn accent-btn" @click="popupFunction()">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M7.2 7.2V2H8.8V7.2H14V8.8H8.8V14H7.2V8.8H2V7.2H7.2Z" fill="white"/>
            </svg>
            Создать участок
          </button>
        </div>
      </div>
    </transition>
    <transition name="popup-opacity">
      <PopupVue
        v-if="isPopup"
        @closePopup="closePopup"
      >
        <template #content>
          <transition name="popup-scale">
            <PopupAddVue></PopupAddVue>
          </transition>
        </template>
      </PopupVue>
    </transition>

    <!-- вид угодий -->
    <transition name="popup-opacity">
      <PopupVue @closePopup="setShowPopup({key: 'tlu', value: false})" v-show="showLandTlu">
        <template #content>
          <transition name="popup-scale">
            <LandTluVue/>
          </transition>
        </template>
      </PopupVue>
    </transition>

    <!-- вид права -->
    <transition name="popup-opacity">
      <PopupVue @closePopup="setShowPopup({key: 'rightType', value: false})" v-show="showLandRights">
        <template #content>
          <transition name="popup-scale">
            <LandRightsVue/>
          </transition>
        </template>
      </PopupVue>
    </transition>

    <!-- вид типа земель -->
    <transition name="popup-opacity">
      <PopupVue @closePopup="setShowPopup({key: 'typeZu', value: false})" v-show="showLandTypeZu">
        <template #content>
          <transition name="popup-scale">
            <LandTypeZuVue/>
          </transition>
        </template>
      </PopupVue>
    </transition>

    <!-- тип субъекта правоотношений -->
    <transition name="popup-opacity">
      <PopupVue @closePopup="setShowPopup({key: 'rightOwnerGovernanceSp', value: false})" v-show="showLandRightOwnerGovernanceSp">
        <template #content>
          <transition name="popup-scale">
            <LandRightOwnerGovernanceSpVue/>
          </transition>
        </template>
      </PopupVue>
    </transition>

    <!-- район -->
    <transition name="popup-opacity">
      <PopupVue @closePopup="setShowPopup({key: 'region', value: false})" v-show="showLandRegion">
        <template #content>
          <transition name="popup-scale">
            <LandRegionVue/>
          </transition>
        </template>
      </PopupVue>
    </transition>

    <PopupVue @closePopup="showAnalytic(false)" v-if="showAnal.show">
      <template #content>
        <div class="analit-wrapp">
          <iframe
            id="frame"
            :src="showAnal.url"
            frameborder="0"
            width="97%"
            height="100%"
          >
          </iframe>
        </div>
      </template>
    </PopupVue>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import PopupVue from '@/components/PopupVue.vue'
import PopupAddVue from './popup/PopupAddVue.vue'
import LandUseListVue from './popup/LandUseListVue.vue'
import LandTluVue from './popup/LandTluVue.vue'
import LandRightsVue from './popup/LandRightsVue.vue'
import LandTypeZuVue from './popup/LandTypeZuVue.vue'
import LandRightOwnerGovernanceSpVue from './popup/LandRightOwnerGovernanceSpVue.vue'
import LandRegionVue from './popup/LandRegionVue.vue'
import ObjectDetailVue from './ObjectDetailVue.vue'
import { eventBus } from '@/main.js'

const GET_LANDS = gql`
query getLands(
  $cursorValue: String,
  $search: String,
  $isCheck: Boolean,
  $isArchive: Boolean,
  $isRented: Boolean,
  $cadCost_Gt: Float,
  $cadCost_Lte: Float
  $areaBygeom_Gt: Float,
  $areaBygeom_Lte: Float,
  $areaBydoc_Gt: Float,
  $areaBydoc_Lte: Float,
  $tlu: [ID],
  $rightType: [ID],
  $typeZu: [ID],
  $rightOwnerGovernanceSp: [ID],
  $region: [ID]
  ){
  landList(
    first: 20,
    after: $cursorValue,
    search: $search,
    isCheck: $isCheck,
    isArchive: $isArchive,
    isRented: $isRented,
    cadCost_Gt: $cadCost_Gt,
    cadCost_Lte: $cadCost_Lte,
    areaBygeom_Gt: $areaBygeom_Gt,
    areaBygeom_Lte: $areaBygeom_Lte,
    areaBydoc_Gt: $areaBydoc_Gt,
    areaBydoc_Lte: $areaBydoc_Lte,
    tlu: $tlu,
    rightType: $rightType,
    typeZu: $typeZu,
    rightOwnerGovernanceSp: $rightOwnerGovernanceSp,
    okatoObj: $region
    ){
    pageInfo{
      hasNextPage
      endCursor
    }
    edges{
      node{
        pk
        id
        regNum
        contourSet {
          edges {
            node {
              geometry {
                type
              }
            }
          }
        }
        location {
          text
          okatoSp {
            text
          }
        }
      }
    }
  }
}
`

// очередь с теме же параметрами что и GET_LANDS(только без first: 10) только это id-шники для карты(используется когда применяются фильтры)
const GET_LANDS_MAP_ID = gql`
query getLandsMapId(
  $cursorValue: String,
  $search: String,
  $isCheck: Boolean,
  $isArchive: Boolean,
  $isRented: Boolean,
  $cadCost_Gt: Float,
  $cadCost_Lte: Float
  $areaBygeom_Gt: Float,
  $areaBygeom_Lte: Float,
  $areaBydoc_Gt: Float,
  $areaBydoc_Lte: Float,
  $tlu: [ID],
  $rightType: [ID],
  $typeZu: [ID],
  $rightOwnerGovernanceSp: [ID],
  $region: [ID]
  ){
  landList(
    after: $cursorValue,
    search: $search,
    isCheck: $isCheck,
    isArchive: $isArchive,
    isRented: $isRented,
    cadCost_Gt: $cadCost_Gt,
    cadCost_Lte: $cadCost_Lte,
    areaBygeom_Gt: $areaBygeom_Gt,
    areaBygeom_Lte: $areaBygeom_Lte,
    areaBydoc_Gt: $areaBydoc_Gt,
    areaBydoc_Lte: $areaBydoc_Lte,
    tlu: $tlu,
    rightType: $rightType,
    typeZu: $typeZu,
    rightOwnerGovernanceSp: $rightOwnerGovernanceSp,
    okatoObj: $region
  ){
    idList
  }
}
`

const GET_DETAIL_EDIT = gql`
query getDetail($pk: Int){
  land(pk: $pk){
    pk
    regNum
    areaBygeom
    areaBydoc
    region
    district
    block
    regNumSource
    cadCost
    cadRegister
    cadRegisterGeom
    nameSystemCoord
    isOks
    groupLand
    factUse
    isUse
    isNoPurpose
    docNoPurpose
    contourSet {
      edges {
        node {
          properties {
            regNum
          }
          geometry {
            type
            coordinates
          }
        }
      }
    }
    photoSet {
      edges {
        node {
          file
          name
        }
      }
    }
    appendixSet {
      edges {
        node {
          file
          name
        }
      }
    }
    typeZu {
      code
      text
    }
    isCheck
    isArchive
    isActual
    actualDate
    createDate
    updateDate
    landTluSet {
      edges {
        node {
          area
          tlu {
            text
            code
          }
        }
      }
    }
    permittedUse {
      landUseMer {
        code
        text
      }
      landUse {
        code
        text
      }
      landUseBydoc
    }
    category {
      code
      text
    }
    location {
      oai
      text
      okato
      note
      kolhoz
      okatoSp {
        text
      }
    }
    note
    store
    photoSet {
      edges {
        node {
          name
          file
          preview
        }
      }
    }
    appendixSet {
      edges {
        node {
          name
          file
        }
      }
    }
    rightSet {
      edges {
        node {
          id
          rightType {
            text
            code
          }
          regNumber
          regDate
          shareNumerator
          shareDenominator
          note
          rightOwnerSet {
            edges {
              node {
                owner {
                  pk
                  sp {
                    text
                    code
                  }
                  name
                  oid
                  governance {
                    name
                  }
                  person {
                    firstName
                    lastName
                    middleName
                    phone
                    address {
                      oai
                      text
                      okato
                      note
                    }
                  }
                  # organizationSet {
                  #   edges {
                  #     node {
                  #       name
                  #       fullName
                  #       ogrn
                  #       phone
                  #     }
                  #   }
                  # }
                  organization {
                    name
                    fullName
                    ogrn
                    phone
                  }
                }
              }
            }
          }
          documentSet {
            edges {
              node {
                documentType {
                  text
                  code
                }
                seria
                number
                date
                notes
                file
              }
            }
          }
          encumbranceSet {
            edges {
              node {
                encumbranceType {
                  text
                  code
                }
                name
                regNumber
                regDate
                dateStarted
                dateStopped
                notes
                documentSet {
                  edges {
                    node {
                      documentType {
                        text
                        code
                      }
                      seria
                      number
                      date
                      notes
                      file
                    }
                  }
                }
                encumbranceOwnerSet {
                  edges {
                    node {
                      owner {
                        pk
                        sp {
                          text
                          code
                        }
                        name
                        oid
                        governance {
                          name
                        }
                        person {
                          firstName
                          lastName
                          middleName
                          phone
                          address {
                            oai
                            text
                            okato
                            note
                          }
                        }
                        # organizationSet {
                        #   edges {
                        #     node {
                        #       name
                        #       fullName
                        #       ogrn
                        #       phone
                        #     }
                        #   }
                        # }
                        organization {
                          name
                          fullName
                          ogrn
                          phone
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`

const GET_DETAIL = gql`
query getDetail($pk: Int){
  land(pk: $pk){
    pk
    regNum
    areaBygeom
    areaBydoc
    region
    district
    block
    regNumSource
    cadCost
    cadRegister
    cadRegisterGeom
    nameSystemCoord
    isOks
    groupLand
    factUse
    isUse
    isNoPurpose
    docNoPurpose
    contourSet {
      edges {
        node {
          properties {
            regNum
          }
          geometry {
            type
            coordinates
          }
        }
      }
    }
    photoSet {
      edges {
        node {
          file
          name
        }
      }
    }
    appendixSet {
      edges {
        node {
          file
          name
        }
      }
    }
    typeZu {
      code
      text
    }
    isCheck
    isArchive
    isActual
    actualDate
    createDate
    updateDate
    landTluSet {
      edges {
        node {
          area
          tlu {
            text
            code
          }
        }
      }
    }
    permittedUse {
      landUseMer {
        code
        text
      }
      landUse {
        code
        text
      }
      landUseBydoc
    }
    category {
      code
      text
    }
    location {
      oai
      text
      okato
      okatoSp {
        text
      }
      note
      kolhoz
    }
    note
    store
    photoSet {
      edges {
        node {
          name
          file
          preview
        }
      }
    }
    appendixSet {
      edges {
        node {
          name
          file
        }
      }
    }
    rightSet {
      edges {
        node {
          id
          rightType {
            text
            code
          }
          rightOwnerSet {
            edges {
              node {
                owner {
                  sp {
                    text
                  }
                  name
                }
              }
            }
          }
          encumbranceSet {
            edges {
              node {
                id
                encumbranceType {
                  code
                }
              }
            }
          }
        }
      }
    }
  }
}
`

const GET_TYPE_ZU = gql`
query GET_TYPE_ZU {
  typeZuList {
    edges {
      node {
        id
        code
        parentCode
        text
      }
    }
  }
}
`

const GET_CATEGORY = gql`
query GET_CATEGORY_LIST{
  categoryList{
    edges{
      node{
        code
        text
      }
    }
  }
}
`

const GET_TLU = gql`
query GET_TLU_LIST {
  tluList {
    edges {
      node {
        id
        code
        parentCode
        text
      }
    }
  }
}
`

const GET_RIGHT = gql`
query GET_RIGHT_TYPE_LIST {
  rightTypeList {
    edges {
      node {
        id
        code
        parentCode
        text
      }
    }
  }
}
`

const GET_GOVERNANCE_SP_LIST = gql`
query GET_GOVERNANCE_SP_LIST {
  governanceSpList {
    edges {
      node {
        id
        code
        parentCode
        text
      }
    }
  }
}
`

const GET_OWNER_TYPE_LIST = gql`
query GET_OWNER_TYPE_LIST {
  ownerTypeList {
    edges {
      node {
        text
        name
      }
    }
  }
}
`

const GET_ENCUMBRANCE_TYPE_LIST = gql`
query encumbranceTypeList {
  encumbranceTypeList {
    edges {
      node {
        parentCode
        code
        text
      }
    }
  }
}
`

const GET_DOCUMENT_TYPE_LIST = gql`
query documentTypeList {
  documentTypeList {
    edges {
      node {
        code
        parentCode
        text
      }
    }
  }
}
`

const GET_LAND_USE_LIST = gql`
query landUseList {
  landUseList {
    edges {
      node {
        code
        parentCode
        text
      }
    }
  }
}
`

const GET_LAND_USE_MER_LIST = gql`
query landUseMerList {
  landUseMerList {
    edges {
      node {
        code
        parentCode
        text
      }
    }
  }
}
`

const GET_REGION_LIST = gql`
query GET_REGION_LIST {
  okatoList {
    edges {
      node {
        parentCode
        okato
        text
      }
    }
  }
}
`

export default {
  name: 'LeftMenuVue',
  components: {
    ObjectDetailVue,
    PopupAddVue,
    LandUseListVue,
    LandTluVue,
    LandRightsVue,
    LandTypeZuVue,
    LandRightOwnerGovernanceSpVue,
    LandRegionVue,
    PopupVue
  },
  data () {
    return {
      settings: {
        suppressScrollX: true
      },
      isOpen: false,
      isActive: false,
      isFull: false,
      objects: [],
      pk: null,
      load: false,
      isShowLoader: false,
      isPopup: false,
      showLanUse: false,
      isSelected: false,
      showLandTlu: false,
      lastClickedIndex: null,
      showLandRights: false,
      showLandTypeZu: false,
      reinitIconGeometry: false,
      showLandRightOwnerGovernanceSp: false,
      showLandRegion: false,
      landList: {},
      inputNoEmpty: false,
      searchResult: '',
      land: {},
      landsMapId: {},
      governanceSpList: {},
      typeZuList: {},
      categoryList: {},
      tluList: {},
      rightTypeList: {},
      ownerTypeList: {},
      encumbranceTypeList: {},
      documentTypeList: {},
      landUseList: {},
      landUseMerList: {},
      regionList: {},
      filterTimer: null,
      tmpFilters: {
        search: '',
        isCheck: '',
        isArchive: '',
        isRented: '',
        cadCost_Gt: '',
        cadCost_Lte: '',
        areaBygeom_Gt: '',
        areaBygeom_Lte: '',
        areaBydoc_Gt: '',
        areaBydoc_Lte: '',
        tlu: [],
        typeZu: [],
        rightType: [],
        showLandTypeZu: [],
        rightOwnerGovernanceSp: [],
        region: []
      },
      filters: {
        search: '',
        isCheck: '',
        isArchive: '',
        isRented: '',
        cadCost_Gt: '',
        cadCost_Lte: '',
        areaBygeom_Gt: '',
        areaBygeom_Lte: '',
        areaBydoc_Gt: '',
        areaBydoc_Lte: '',
        tlu: [],
        typeZu: [],
        rightType: [],
        showLandTypeZu: [],
        rightOwnerGovernanceSp: [],
        region: []
      },
      inputTimer: null
    }
  },
  apollo: {
    landList: {
      query: GET_LANDS,
      variables () {
        return this.createVariables(this.filters)
      }
    },
    landsMapId: {
      query: GET_LANDS_MAP_ID,
      variables () {
        return this.createVariables(this.filters)
      },
      update: data => {
        return data.landList.idList
      },
      error (error) {
        console.log('fail get land ids for map', error)
        this.$store.dispatch('SET_VALUE', {key: 'isMapFilter', value: false})
        this.landsMapId = []
        this.$notify({
          group: 'foo',
          type: 'error',
          title: 'Ошибка',
          text: 'Не удалось обновить карту. Будут отображены все участки'
        })
      },
      skip () { // не запрашиваем, если нет фильтров
        let skip = true
        let filters = this.createVariables(this.filters)
        let countFilters = 0
        /* eslint-disable-next-line */
        for (let key in filters) { // считаем количество применяемых фильтров
          countFilters++
        }
        if (countFilters > 0) { // если не ноль, то не запрашиваем ИД тех кого отобразить
          skip = false
        } else { // иначе skip остается true и передаем в карту что надо отрисовать все участки
          this.landsMapId = null
        }
        return skip
      }
    },
    typeZuList: {
      query: GET_TYPE_ZU
    },
    categoryList: {
      query: GET_CATEGORY
    },
    tluList: {
      query: GET_TLU
    },
    rightTypeList: {
      query: GET_RIGHT
    },
    governanceSpList: {
      query: GET_GOVERNANCE_SP_LIST
    },
    ownerTypeList: {
      query: GET_OWNER_TYPE_LIST
    },
    encumbranceTypeList: {
      query: GET_ENCUMBRANCE_TYPE_LIST
    },
    documentTypeList: {
      query: GET_DOCUMENT_TYPE_LIST
    },
    landUseList: {
      query: GET_LAND_USE_LIST
    },
    landUseMerList: {
      query: GET_LAND_USE_MER_LIST
    },
    regionList: {
      query: GET_REGION_LIST,
      update: data => {
        this.regionList = data
        return data
      }
    }
  },
  computed: {
    permisCreate () {
      return this.checkHavePermissionMix('change_', '*')
    },
    noResult () {
      return ('edges' in this.landList && this.landList.edges.length === 0)
    },
    isFullInfo () {
      return this.$store.getters.value('isFullInfo')
    },
    encumbranceDetail () {
      return this.$store.getters.value('encumbranceDetail')
    },
    showAnal () {
      return this.$store.getters.value('showAnal')
    },
    leftMenuDisplayMedia () {
      return this.$store.getters.value('leftMenuDisplayMedia')
    },
    encIndex () {
      return this.$store.getters.value('encIndex')
    }
  },
  watch: {
    landsMapId (newVal) {
      eventBus.$emit('setFilterMap', newVal)
    },
    typeZuList (newVal) {
      this.$store.dispatch('SET_TYPE_ZU_LIST', newVal)
    },
    categoryList (newVal) {
      this.$store.dispatch('SET_CATEGORY_LIST', newVal)
    },
    tluList (newVal) {
      this.$store.dispatch('SET_TLU_LIST', newVal)
    },
    rightTypeList (newVal) {
      this.$store.dispatch('SET_RIGHT_LIST', newVal)
    },
    governanceSpList (newVal) {
      this.$store.dispatch('SET_RIGHT_OWNER_GOVERNANCE_SP_LIST', newVal)
    },
    ownerTypeList (newVal) {
      this.$store.dispatch('SET_OWNER_TYPE_LIST', newVal)
    },
    encumbranceTypeList (newVal) {
      this.$store.dispatch('SET_ENCUMBRANCE_TYPE_LIST', newVal)
    },
    documentTypeList (newVal) {
      this.$store.dispatch('SET_DOCUMENT_TYPE_LIST', newVal)
    },
    landUseList (newVal) {
      this.$store.dispatch('SET_LAND_USE_LIST', newVal)
    },
    landUseMerList (newVal) {
      this.$store.dispatch('SET_LAND_USE_MER_LIST', newVal)
    },
    regionList (newVal) {
      this.$store.dispatch('SET_REGION_LIST', newVal)
    },
    landList () {
      this.reinitIconGeometry = true
      setTimeout(() => {
        this.reinitIconGeometry = false
      }, 10)
    }
  },
  methods: {
    emitEdit (pk) {
      // console.log(pk)
      if (pk === undefined) {
        return
      }
      this.isPopup = true
      this.$store.dispatch('SET_VALUE', {key: 'editLoading', value: true})
      setTimeout(() => {
        eventBus.$emit('openEdit', pk)
        this.$apollo.query({
          query: GET_DETAIL_EDIT,
          fetchPolicy: 'no-cache',
          variables: {
            pk: pk
          }
        }).then(response => {
          this.$store.dispatch('SET_VALUE', {key: 'landEdit', value: response.data.land})
          this.$store.dispatch('SET_VALUE', {key: 'editLoading', value: false})
        })
      }, 50)
    },

    showAnalytic (val) {
      this.$store.dispatch('SET_VALUE', {key: 'showAnal', value: false})
    },

    activeItem (index) {
      // console.log(index)
      this.lastClickedIndex = index
    },
    createVariables (filters, pageInfo) { // принимает фильтры и pageInfo возвращает объект который можно передеавать в variables квери
      let _filters = {}
      for (let key in filters) { // все значения кроме пустых
        if (Array.isArray(filters[key])) { // если это массив(в противном случае это строка)
          if (filters[key].length > 0) {
            _filters[key] = filters[key]
          }
        } else {
          if (filters[key] !== '') {
            _filters[key] = filters[key]
          }
        }
      }
      if (pageInfo !== undefined && pageInfo.endCursor !== '') {
        _filters.cursorValue = pageInfo.endCursor
      }
      return _filters
    },

    popupFunction () {
      this.isPopup = true
    },

    showMore () { // если есть след страница запрашивает еще одну, объединяя данны
      if (this.landList.pageInfo === undefined || !this.landList.pageInfo.hasNextPage) { // если данных еще нет или нет следующей страницы, то не запрашивать
        return
      }
      let _variables = this.createVariables(this.filters, this.landList.pageInfo) // создаем переменные
      this.isShowLoader = true
      this.$apollo.queries.landList.fetchMore({
        variables: _variables,
        updateQuery: (previousResult, { fetchMoreResult }) => {
          this.isShowLoader = false
          const newLand = fetchMoreResult.landList.edges
          return {
            landList: {
              pageInfo: fetchMoreResult.landList.pageInfo,
              hasNextPage: previousResult.landList.pageInfo.hasNextPage,
              __typename: previousResult.landList.__typename,
              edges: [...previousResult.landList.edges, ...newLand] // объединяем новые и старые данные
            }
          }
        }
      })
    },

    visibilityChanged (isVisible, entry) { // срабатывает при прокручивани списка до низа
      if (isVisible) {
        this.showMore()
      }
    },

    clearSearch () {
      this.searchResult = ''
      this.setLandListFilter({key: 'search', value: ''})
      this.acceptFilter()
      this.inputNoEmpty = false
    },

    searchInput (e) { // задержка на ввод в поиск
      if (this.inputTimer !== null) {
        clearTimeout(this.inputTimer)
      }
      if (e !== null) {
        this.inputNoEmpty = true
      } else {
        this.inputNoEmpty = false
      }
      this.setLandListFilter({key: 'search', value: e.srcElement.value}) // устанавливаем фильтр
      this.inputTimer = setTimeout(() => { // если не вводят дальше, то применяем его
        eventBus.$emit('boundFeature', null) // сбросить выделение
        this.acceptFilter()
      }, 1500)
    },

    setLandListFilter (e) { // устанавливаем фильтры
      if (e.value !== undefined && this.tmpFilters[e.key] === e.value) { // если значение которое есть равно новому ничего не делать
        return
      }
      if (e.value === undefined || e.value === null) {
        console.warn('do not use undefined as a value')
        e.value = ''
      }
      this.tmpFilters[e.key] = e.value // меняем фильтр в объект filters(запрос произойдет автоматически)
      if (this.filterTimer !== null) {
        clearTimeout(this.filterTimer)
      }
      // this.filterTimer = setTimeout(() => {
      //   this.$set(this, 'filters', JSON.parse(JSON.stringify(this.tmpFilters)))
      //   this.$store.dispatch('SET_VALUE', {key: 'isMapFilter', value: true})
      // }, 1000)
    },

    acceptFilter () { // применяет фильтр
      if (JSON.stringify(this.tmpFilters) !== JSON.stringify(this.filters)) { // если  фильтр изменили, то начинает загрузку. Если тот же, то ничего не делаем
        this.$store.dispatch('SET_VALUE', {key: 'isMapFilter', value: true})
        this.$set(this, 'filters', JSON.parse(JSON.stringify(this.tmpFilters)))
      }
    },

    showOnMap (pk) {
      eventBus.$emit('boundFeature', {pk: pk})
    },

    closePopup () {
      this.isPopup = false
    },

    selectLand (landPk) {
      if (this.encumbranceDetail.length !== 0) {
        this.$store.dispatch('SET_VALUE', {key: 'encumbranceDetail', value: []})
      }
      this.$store.dispatch('SET_VALUE', {key: 'isFullInfo', value: true})
      this.pk = Number(landPk)
      this.$store.dispatch('SET_VALUE', {key: 'loadingLandDetail', value: true})
      this.$apollo.query({
        query: GET_DETAIL,
        fetchPolicy: 'no-cache',
        variables: {
          pk: this.pk
        }
      }).then(response => {
        this.land = response.data.land
        this.isFull = true
        this.$store.dispatch('SET_VALUE', {key: 'land', value: this.land})
        this.$store.dispatch('SET_VALUE', {key: 'loadingLandDetail', value: false})
      }).catch(err => {
        this.$store.dispatch('SET_VALUE', {key: 'isFullInfo', value: false})
        this.$store.dispatch('SET_VALUE', {key: 'loadingLandDetail', value: false})
        console.error('fail get detail info about land', err)
      })
    },

    qwe () {
      // this.$apollo.resetStore()
      // console.log(this.$apollo)
      // console.log(this.$apolloProvider)
      // console.log(this.landList)
    },

    setShowPopup (e) {
      switch (e.key) {
        case 'tlu':
          this.showLandTlu = e.value
          break

        case 'rightType':
          this.showLandRights = e.value
          break

        case 'typeZu':
          this.showLandTypeZu = e.value
          break

        case 'rightOwnerGovernanceSp':
          this.showLandRightOwnerGovernanceSp = e.value
          break

        case 'region':
          this.showLandRegion = e.value
          break

        default:
          break
      }
    },

    deselectIdLandListFilter (e) {
      let idIndex = this.tmpFilters[e.key].findIndex(item => {
        return item === e.id
      })
      // console.log('idIndex', idIndex)
      if (idIndex !== -1) {
        this.tmpFilters[e.key].splice(idIndex, 1)
      }
      if (this.filterTimer !== null) {
        clearTimeout(this.filterTimer)
      }
      // this.filterTimer = setTimeout(() => {
      //   this.$set(this, 'filters', JSON.parse(JSON.stringify(this.tmpFilters)))
      // }, 2000)
    },

    finishCeateEdit (pk) {
      this.isPopup = false
      if (pk !== null && pk !== undefined) {
        this.selectLand(pk)
        this.showOnMap(pk)
      }
    },
    finishDeleteObject () {
      this.isPopup = false
    },

    hideLeftMenuDisplayMedia () {
      this.$store.dispatch('SET_VALUE', {key: 'leftMenuDisplayMedia', value: false})
    }
  },
  created () {
    const onClickOutside = e => (this.isActive = this.$el.contains(e.target) && this.isActive)
    document.addEventListener('click', onClickOutside)
    this.$on('hook:beforeDestroy', () => document.removeEventListener('click', onClickOutside))
    eventBus.$on('selectLandByPk', this.selectLand)
    eventBus.$on('setLandListFilter', this.setLandListFilter) // слушаем шину событий
    eventBus.$on('setShowPopup', this.setShowPopup) // слушаем шину событий
    eventBus.$on('deselectIdLandListFilter', this.deselectIdLandListFilter) // слушаем шину событий
    eventBus.$on('finishCeateEdit', this.finishCeateEdit) // слушаем шину событий
    eventBus.$on('finishDeleteObject', this.finishDeleteObject)
    eventBus.$on('acceptFilter', this.acceptFilter)
  },

  mounted () {
    if (this.$route.params.pk !== undefined) {
      this.selectLand(this.$route.params.pk)
      this.showOnMap(this.$route.params.pk)
    }
  },

  beforeDestroy () {
    eventBus.$off('selectLandByPk')
    eventBus.$off('setLandListFilter')
    eventBus.$off('setShowPopup')
    eventBus.$off('deselectFromArrayLandListFilter')
    eventBus.$off('finishCeateEdit')
    eventBus.$off('finishDeleteObject')
  }
}
</script>

<style lang="scss">
.preloader {
  position: fixed;
  width: 245px;
  top: 135px;
  height: 100%;
  background-color: rgba(255, 255, 255, .6);
}

.pr-2 {
  top: auto;
  bottom: 130px;
  left: 0;
  height: 0;
  width: 245px;
}

.pr-3 {
  top: 140px;
  bottom: auto;
  width: 375px;
}

.loader {
  position: absolute;
  max-width: 50px;
  stroke-linecap: round;
  top: 0;
  left: 40%;
}

.lr-2 {
  left: 60%;
}

.lr-3 {
  top: 20%;
}

circle {
  fill: none;
  stroke-width: 10px;
  animation-name: preloader;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  transform-origin: 170px 170px;
  will-change: transform;

  &:nth-of-type(1) {
    stroke-dasharray: 550px;
  }

  &:nth-of-type(2) {
    stroke-dasharray: 500px;
  }

  &:nth-of-type(3) {
    stroke-dasharray: 450px;
  }

  &:nth-of-type(4) {
    stroke-dasharray: 300px;
  }

  @for $i from 1 through 4 {
    &:nth-of-type(#{$i}) {
      animation-delay: -#{$i * 0.15}s;
    }
  }
}

@keyframes preloader {
  50% {
    transform: rotate(360deg);
  }
}

.slide-hide-enter-active,
.slide-hide-leave-active {
  transition: all .2s;
}
.slide-hide-enter,
.slide-hide-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all .3s;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.left-menu-wrap {
  position: absolute;
  top: 0;
  left: 0;
  flex: none;
  padding: 0 50px 0 0;
  overflow: hidden;
  background-color: #fff;
  width: 305px;
  min-height: 100%;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  z-index: 3;
  transition: .3s;
  &.full {
    width: 420px;
    &.very-full {
      width: 880px;
    }
  }
  @media screen and (max-width: 768px){
    max-width: 100%;
    padding: 0 0 0 20px;
  }
  .open-menu {
    position: absolute;
    top: 30px;
    right: -30px;
    width: 30px;
    height: 40px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border: 1px solid #e6e6e6;
    z-index: 1;
  }
}
.left-menu {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-right: 30px;
  width: 100%;
  min-height: calc(100% - 10px);
  @media screen and (max-width: 768px){
    width: calc(100% - 20px);
  }
  &-item {
    position: relative;
    cursor: pointer;
    margin-top: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #e6e6e6;
    // overflow: hidden;
    transition: .3s;
    &:first-child {
      margin-top: 0;
    }
    &.active {
      color: #4E53E7;
    }
    p {
      margin-bottom: 0;
    }
    .cadastral {
      display: flex;
      align-items: flex-start;
      img {
        margin-left: 15px;
      }
    }
    .cadastral-number {
      font-family: 'Montserrat_B';
      margin-bottom: 10px;
    }
    .geometry {
      position: absolute;
      right: 60px;
    }
    &:hover {
      .left-menu-functional {
        opacity: 1;
        right: 0;
        button:first-child {
          @media screen and (max-width: 768px){
            display: none;
          }
        }
      }
    }
  }
  &-functional {
    position: absolute;
    opacity: 0;
    top: 0;
    right: -100px;
    transition: .3s;
    button {
      margin-left: 10px;
    }
  }
  .scroll-menu {
    position: absolute;
    margin-top: 20px;
    top: 50px;
    width: 100%;
    height: calc(100% - 140px);
    box-shadow: 0px 15px 8px -21px #000000;
    .items-wrap {
      padding-left: 30px;
      margin-right: 30px;
    }
    @media screen and (max-width: 768px){
      height: calc(100% - 60px);
    }
  }
  .create-object {
    position: relative;
    margin-left: 30px;
    @media screen and (max-width: 768px){
      display: none;
    }
    button,
    a {
      display: block;
      width: 100%;
      text-align: center;
      font-size: 14px;
      svg {
        vertical-align: bottom;
      }
    }
    a {
      margin-top: 15px;
      color: #4E53E7;
    }
  }
}
.search {
  position: relative;
  margin-left: 30px;
  &-icon {
    position: absolute;
    top: 49%;
    left: 20px;
    transform: translateY(-50%);
    // z-index: 9;
  }
  &-input {
    padding: 12px 40px;
    font-size: 14px;
    width: 100%;
    background-color: #f2f2f2;
    border: 1px solid transparent;
    border-radius: 8px;
    transition: .3s;
    &:focus {
      border-color: #c8caef;
    }
  }
  .clear {
    position: absolute;
    top: 55%;
    right: 15px;
    transform: translateY(-50%);
    z-index: 1;
  }
  &-category {
    position: absolute;
    display: block;
    top: 49%;
    transform: translateY(-50%);
    right: 20px;
    span {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      width: 12px;
      height: 2px;
      background-color: #545454;
      transition: .3s;
      &:before,
      &:after {
        position: absolute;
        content: "";
        width: 100%;
        height: 2px;
        background-color: #545454;
        left: 0;
        transition: .3s;
      }
      &:before {
        top: -4px;
      }
      &:after {
        bottom: -4px;
      }
    }
    &.is-active {
      span {
        transform: rotate(45deg);
        width: 15px;
        &:before {
          opacity: 0;
        }
        &:after {
          bottom: 0;
          transform: rotate(-90deg);
        }
      }
    }
  }
  &-block {
    position: absolute;
    opacity: 0;
    visibility: hidden;
    width: 100%;
    top: -50px;
    padding: 15px 35px 5px 0;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.08);
    z-index: 1;
    transition: .3s;
    label {
      position: relative;
      display: block;
      padding-left: 40px;
      margin-bottom: 15px;
      font-size: 14px;
      cursor: pointer;
      img {
        position: absolute;
        transform: scale(0);
        left: 20px;
        transition: .3s;
      }
      input:checked + img {
        transform: scale(1);
      }
    }
    &.is-active {
      opacity: 1;
      visibility: visible;
      top: 45px;
    }
  }
}

.hide-search {
  width: 40px;
  height: 40px;
  position: absolute;
  right: 5px;
  top: 12px;
  display: none;

  img{
    width: 50%;
    height: 50%;
    transform: rotate(90deg);
  }
  @media screen and (max-width: 768px){
    display: block;
  }
}

.load-trigger {
  width: 100%;
  height: 2px;
}
.analit-wrapp {
  width: 95vw;
  height: 95vh;
  padding: 5px;
  z-index: 9;
}
@media print {
  .left-menu-wrap,
  .top-right,
  .change-map-control,
  .header,
  .btn-filter,
  .mapboxgl-ctrl-top-right,
  .change-style-layer {
    display: none !important;
  }
  .main-component {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/LeftMenuVue.vue